// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__g_rVH","row":"ProcedureTreatmentSummary_row__32LVR"};